import React from 'react';
import Logo from '../assets/logo.png';


function NavBar() {
  return (
    <nav className="navbar navbar-default main-navigation shadow p-3 mb-5 bg-white rounded ">
             <div className="navbar-header">
                 <a className="navbar-brand" >
                     <img src={Logo} alt="Lin Li Lab"/>
                 </a>
             </div>
             <div className="slide-menu-wrap">
                 <div className="navbar-collapse">
                     <ul className="nav navbar-nav d-flex flex-row">
                         <li className=""><a href="http://compbio.utep.edu/">Home</a></li>
                         <li className=""><a href="http://compbio.utep.edu/news/">News</a></li>
                         <li className="active"><a href="http://compbio.utep.edu/webservers/">WebServers</a></li>
                         <li className=""><a href="http://compbio.utep.edu/software/">Software</a></li>
                         <li className=""><a href="http://compbio.utep.edu/members/">Members</a></li>
                         <li className=""><a href="http://compbio.utep.edu/publications/">Publications</a></li>
                         <li className=""><a href="http://compbio.utep.edu/employments/">Employment</a></li>
                         <li className=""><a href="http://compbio.utep.edu/contacts/">Contact</a></li>
                     </ul>
                 </div>
             </div>
     </nav>
  );
}





export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar.js